module.exports = __webpack_public_path__ + "static/media/home-depot.dcea5b34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/home-depot.jpg
// module id = 783
// module chunks = 27